export default __webpack_public_path__ + "static/media/4.0c10d36f.jpg";